/**
 * ЭТАП 1 · Шаг 3 — кастомный клиентский entry TanStack Start.
 *
 * Дефолтный entry (@tanstack/react-start/dist/plugin/default-entry/client.tsx)
 * оборачивает приложение в <StrictMode>. StrictMode в dev симулирует
 * unmount+remount (cDM → cWU → cDM), а react-yandex-maps@4.6 к этому не готов:
 * при повторном маунте state.instance ещё null, destroy() не вызывается, и
 * первый инстанс карты остаётся сиротой в том же div → ДВОЙНАЯ карта на всех
 * страницах с ymaps (+ двойная загрузка api-maps скрипта).
 *
 * Легаси-приложение никогда не работало под StrictMode (старый entry index.js
 * рендерил без него), поэтому здесь гидрируем без StrictMode — 1:1 со старым
 * поведением. Возврат StrictMode — отдельный техдолг после ухода с
 * react-yandex-maps.
 */
// ПЕРВЫМ импортом: вход по ссылке с токенами (?_peopleToken&_cartToken)
// срабатывает при вычислении модуля — раньше сторов, которые читают
// localStorage при импорте, и раньше гидрации. См. src/utils/authLink.ts
import { isAuthLinkRedirecting } from '@utils/authLink';
import { startTransition } from 'react';
import { hydrateRoot } from 'react-dom/client';
import { StartClient } from '@tanstack/react-start/client';
import { installDeployRecovery } from '@utils/deployRecovery';

// Ссылка с токенами уже перезагружает страницу — гидрировать нечего
if (!isAuthLinkRedirecting) {
  // Раньше гидрации и раньше любого ленивого импорта: вкладка, пережившая
  // деплой, чинится одной перезагрузкой вместо экрана «Что-то пошло не так»
  installDeployRecovery();

  startTransition(() => {
    hydrateRoot(document, <StartClient />);
  });
}
